/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
export const findOption = <T>(value: string, options: T[], keyName: keyof T) =>
  options.find((opt) => opt[keyName] === value);

export const findMultipleOptions = <T>(
  values: Record<string, T>[],
  options: Record<string, T>[],
  keyName: keyof Record<string, T>,
) => values.map((value) => options.find((opt) => value[keyName] === opt.key));